export class SubcategoriasModel {
    constructor(
        public id_subcategoria: number,
        public id_categoria: number,
        public nombre_subcategoria: string
    ) { }
}